import { useSiteTextContent } from "@Front/Stores/SiteTextsContext";

export type StepPasswordCopy = {
	formTitle: string;
	passwordPlaceholder: string;
	passwordForgottenLink: string;
	formSubmitCta: string;
	modalTitle: string;
	modalBody: string;
	modalConfirm: string;
	modalCancel: string;
};

export function useStepPasswordCopy(): StepPasswordCopy {
	return {
		formTitle: useSiteTextContent("login.form.password.title"),
		passwordPlaceholder: useSiteTextContent("login.form.password.placeholder"),
		passwordForgottenLink: useSiteTextContent("login.form.passwordForgotten.link"),
		formSubmitCta: useSiteTextContent("login.form.submit.validate"),
		modalTitle: useSiteTextContent("login.modal.passwordForgotten.title"),
		modalBody: useSiteTextContent("login.modal.passwordForgotten.body"),
		modalConfirm: useSiteTextContent("login.form.submit.validate"),
		modalCancel: useSiteTextContent("login.modal.passwordForgotten.cancel"),
	};
}
